<wbo-screen-layout-button (click)="model.selectMenu(menu)"
                          [item]="menu"
                          [selected]="menu === (model.selectedMenu$ | async)"
                          (navigated)="navigated$.emit()"
                          [leftCommandsToggled]="isLeftCommandsToggled"
                          [rightCommandsToggled]="isRightCommandsToggled" [showLeftCommands]="!(model.painting$ | async) && showLeftCommands"
                          [showNavigateTo]="(model.numOfRows$ | async) <= 10" [showRightCommands]="!(model.painting$ | async) && showRightCommands">
    <ng-template #leftCommands>
        <fui-commands [showPopupForSingleItems]="true" icon="plus"
                      (toggled$)="leftCommandsToggled($event)">
            <fui-command (clicked$)="model.insertMenu(menu)"
                         [title]="'wbo.screen-layout.edit.action.touchItem.addMenu'">
            </fui-command>
        </fui-commands>
    </ng-template>
    <ng-template #rightCommands>
        <fui-commands [showPopupForSingleItems]="true" icon="delete"
                      (toggled$)="rightCommandsToggled($event)">
            <fui-command (clicked$)="model.removeMenu(menu)"
                         [title]="'wbo.screen-layout.edit.action.touchItem.remove'">
            </fui-command>
        </fui-commands>
    </ng-template>
</wbo-screen-layout-button>
